// src/components/Cancel.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function Cancel() {
  return (
    <section style={styles.section}>
      <div style={styles.card}>
        <div style={styles.iconCircle}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M6 6l12 12M18 6L6 18" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1 style={styles.h1}>We're sad to see you go</h1>
        <p style={styles.sub}>
          Your checkout was cancelled and your card wasn't charged. If you change your mind, we'll be right here — come back and give Shepherd a try whenever you're ready.
        </p>

        <div style={styles.actions}>
          <Link to="/" style={styles.btnPrimary}>Back to home</Link>
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: {
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'clamp(2rem, 6vw, 6rem) 1.5rem',
    marginTop: '64px',
    background: 'radial-gradient(ellipse 60% 70% at 70% 30%, rgba(26,115,232,0.07) 0%, transparent 70%), var(--warm-white)',
  },
  card: {
    maxWidth: 480,
    width: '100%',
    textAlign: 'center',
    background: 'white',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-lg)',
    padding: 'clamp(2rem, 5vw, 3rem)',
    boxShadow: '0 32px 80px rgba(26,31,54,0.08), 0 4px 16px rgba(26,31,54,0.04)',
    animation: 'fadeUp 0.6s ease both',
  },
  iconCircle: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    background: 'var(--text-muted)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 1.5rem',
  },
  h1: {
    fontFamily: "'Sora', sans-serif",
    fontSize: 'clamp(1.8rem, 4vw, 2.4rem)',
    fontWeight: 700,
    color: 'var(--charcoal)',
    marginBottom: '0.75rem',
  },
  sub: {
    fontSize: '1.05rem',
    color: 'var(--text-muted)',
    fontWeight: 300,
    lineHeight: 1.7,
    marginBottom: '2rem',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    justifyContent: 'center',
  },
  btnPrimary: {
    display: 'inline-flex', alignItems: 'center', gap: 8,
    background: 'var(--brand)', color: 'white',
    padding: '13px 26px', borderRadius: 'var(--radius-md)',
    fontSize: '1rem', fontWeight: 500,
    textDecoration: 'none', cursor: 'pointer',
    transition: 'background 0.2s, transform 0.15s',
  },
};
